import styled from "styled-components";
import { COLORS } from "../../styles/constants.style";

export const ErrorWarningWrapper = styled.div`
  .error-warning,
  .error-warning-list {
    margin: 16px;
  }

  .error-warning-list {
    margin-top: 8px;
  }

  .error-warning-header-wrapper {
    padding: 0px 16px;
    display: flex;
    align-items: center;
  }

  .error-warning-header {
    color: ${COLORS.cirrus_red};
    line-height: 20px;
  }

  .error-warning-header-badge {
    background: ${COLORS.cirrus_red};
    color: ${COLORS.cirrus_white};
    line-height: 22px;
    padding: 2px 8px;
    margin-left: 8px;
    border-radius: 5px;
  }
`;
